<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <buy-types-filter :get-report-data="getBuyTypes" />
        <b-card>
          <flat-card
            color="primary"
            icon="CheckCircleIcon"
            title="Alımlar Toplamı"
            :value="buyTypes.grandTotals.sales"
          />
          <b-row>
            <b-col
              cols="12"
              md="7"
            >
              <b-list-group class="mt-2">
                <b-list-group-item
                  v-for="(item,key) in buyTypes.data"
                  :key="key"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <div>{{ item.title }}</div>
                    <div>
                      <b-badge variant="primary">
                        {{ item.count }}
                      </b-badge>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <pie-charts
                v-if="buyTypes.grandTotals.chartData.series.length"
                :categories-data="buyTypes.grandTotals.chartData.labels"
                :series-data="buyTypes.grandTotals.chartData.series"
                chart-type="donut"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'
import Loading from '@/layouts/components/Loading.vue'
import BuyTypesFilter from '@/views/I2Sales/FilterCards/BuyTypesFilter.vue'

export default {
  name: 'RacI2Sales',
  components: {
    BRow,
    BCol,
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
    FlatCard,
    PieCharts,
    Loading,
    BuyTypesFilter,
  },
  computed: {
    loading() {
      return this.$store.getters['i2SalesReports/loading']
    },
    buyTypes() {
      return this.$store.getters['i2SalesReports/buyTypes']
    },
    buyTypesParams() {
      return this.$store.getters['i2SalesReports/buyTypesParams']
    },
  },
  created() {
    this.getBuyTypes()
  },
  methods: {
    getBuyTypes() {
      this.$store.dispatch('i2SalesReports/getBuyTypes', this.buyTypesParams)
    },
  },
}
</script>
